import { httpClient } from '../httpClient';

/**
 * Classification Scan API -- scan-related endpoints.
 * Extracted from classification.js (T117).
 */
export const classificationScanApi = {
  // ── Scans ──────────────────────────────────────────────────────────────
  getScanHistory: (params) =>
    httpClient.get('/classification/scans', { params }),

  triggerScan: (body) =>
    httpClient.post('/classification/scans', body),

  getScanRunStatus: (scanId) =>
    httpClient.get(`/classification/scans/${scanId}/status`),

  // Returns the currently-running scan (or null) so the global indicator
  // can re-attach to a backend job after navigation, page reload, or login.
  getActiveScan: () =>
    httpClient.get('/classification/scans/active'),

  cancelScan: (scanId) =>
    httpClient.post(`/classification/scans/${scanId}/cancel`),

  previewScan: (body) =>
    httpClient.post('/classification/scans/preview', body),

  // ── Rules ──────────────────────────────────────────────────────────────
  getRules: (params) =>
    httpClient.get('/classification/rules/', { params }),

  createRule: (data) =>
    httpClient.post('/classification/rules', data),

  updateRule: (id, data) =>
    httpClient.put(`/classification/rules/${id}`, data),

  deleteRule: (id) =>
    httpClient.delete(`/classification/rules/${id}`),

  seedRules: () =>
    httpClient.post('/classification/rules/seed'),

  testRule: (id, data) =>
    httpClient.post(`/classification/rules/${id}/test`, data),

  // T477 (FR-055): test an UNSAVED draft rule payload against the shared
  // scanner-parity matcher (server-side, Unicode-aware) so the live preview
  // predicts the real scan. Rejects exactly what rule creation would reject.
  testRuleDraft: (payload) =>
    httpClient.post('/classification/rules/test-draft', payload),

  getRuleImpactCount: (id) =>
    httpClient.get(`/classification/rules/${id}/impact-count`),

  getRuleTestTemplate: (ruleId) =>
    httpClient.get(`/classification/rules/${ruleId}/test-template`),

  runAgainstSource: (data) =>
    httpClient.post('/classification/rules/run-against-source', data),

  // ── Schedules ──────────────────────────────────────────────────────────
  getSchedules: () =>
    httpClient.get('/classification/schedules'),

  createSchedule: (data) =>
    httpClient.post('/classification/schedules', data),

  updateSchedule: (id, data) =>
    httpClient.put(`/classification/schedules/${id}`, data),

  toggleSchedule: (id) =>
    httpClient.patch(`/classification/schedules/${id}/toggle`),

  deleteSchedule: (id) =>
    httpClient.delete(`/classification/schedules/${id}`),

  // ── Patterns ───────────────────────────────────────────────────────────
  getPatterns: (queryString) =>
    httpClient.get(`/classification/patterns?${queryString}`),

  getPatternStats: () =>
    httpClient.get('/classification/patterns/stats'),

  updatePattern: (id, data) =>
    httpClient.put(`/classification/patterns/${id}`, data),

  deletePattern: (id) =>
    httpClient.delete(`/classification/patterns/${id}`),

  // ── Triage ─────────────────────────────────────────────────────────────
  getTriageConfig: () =>
    httpClient.get('/classification/triage/config'),

  getTriageSummary: (queryString) =>
    httpClient.get(`/classification/triage/summary${queryString ? `?${queryString}` : ''}`),

  updateTriageConfig: (data) =>
    httpClient.put('/classification/triage/config', data),

  reEvaluateTriage: () =>
    httpClient.post('/classification/triage/re-evaluate'),

  ensureTriaged: () =>
    httpClient.post('/classification/triage/ensure-triaged'),

  // ── Quality ────────────────────────────────────────────────────────────
  getQualityReport: (sourceId) =>
    httpClient.get(`/classification/quality/source/${sourceId}`),

  getQualitySummary: () =>
    httpClient.get('/classification/quality/summary'),

  runQualityCheck: (sourceId) =>
    httpClient.post(`/classification/quality/assess/${sourceId}`),

  exportQualityReport: (sourceId) =>
    httpClient.get(`/classification/quality/export/${sourceId}`),

  // ── EDM Reference Sets ─────────────────────────────────────────────────
  listEDMSets: (params) =>
    httpClient.get('/classification/edm/reference-sets', { params }),

  createEDMSet: (data) =>
    httpClient.post('/classification/edm/reference-sets', data),

  updateEDMSet: (id, data) =>
    httpClient.patch(`/classification/edm/reference-sets/${id}`, data),

  deleteEDMSet: (id) =>
    httpClient.delete(`/classification/edm/reference-sets/${id}`),

  uploadEDMCsv: (id, formData) =>
    httpClient.post(`/classification/edm/reference-sets/${id}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
